import { useEffect, useRef, useState } from 'react';

const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

const CountUp = ({ end = 0, duration = 1600, prefix = '', suffix = '', className = '' }) => {
    const [value, setValue] = useState(0);
    const [started, setStarted] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        setStarted(true);
                        io.disconnect();
                    }
                });
            },
            { threshold: 0.3 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);

    useEffect(() => {
        if (!started) return;
        let raf;
        const startTs = performance.now();
        const tick = (now) => {
            const p = Math.min(1, (now - startTs) / duration);
            setValue(Math.round(end * easeOutExpo(p)));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [started, end, duration]);

    const formatted = value.toLocaleString('en-IN');
    return (
        <span ref={ref} className={`tabular-nums ${className}`}>
            {prefix}
            {formatted}
            {suffix}
        </span>
    );
};

export default CountUp;
